import styled from "styled-components";

export const Container = styled.section`
  width: 100%;
  height: 100vh;
  background: #fff;
  position: absolute;
  z-index: 2;
  padding: 4rem 3rem;
  -webkit-animation: scale-up-ver-top 0.4s ease-in both;
  animation: scale-up-ver-top 0.4s ease-in both;

  nav {
    ul {
      list-style: none;

      li {
        font-size: 22px;
        font-weight: 600;

        & + li {
          margin-top: 2rem;
        }

        button {
          text-decoration: none;
          color: #000;
          background: none;
          border: none;
          font-weight: bold;
          font-size: 16px;
        }
        .button-doar{
          background-color: #1484c7;
          width: 100px;
          height: 30px;
          border-radius: 5px;
          padding: 1px;
          color: white;
          :hover{
            background-color: #1485c7c6;
            color: #000;
            border: 2px solid #1484c7;
          }
        }
      }
    }
  }

  @-webkit-keyframes scale-up-ver-top {
    0% {
      -webkit-transform: scaleY(0.4);
      transform: scaleY(0.4);
      -webkit-transform-origin: 100% 0%;
      transform-origin: 100% 0%;
    }
    100% {
      -webkit-transform: scaleY(1);
      transform: scaleY(1);
      -webkit-transform-origin: 100% 0%;
      transform-origin: 100% 0%;
    }
  }

  @keyframes scale-up-ver-top {
    0% {
      -webkit-transform: scaleY(0.4);
      transform: scaleY(0.4);
      -webkit-transform-origin: 100% 0%;
      transform-origin: 100% 0%;
    }
    100% {
      -webkit-transform: scaleY(1);
      transform: scaleY(1);
      -webkit-transform-origin: 100% 0%;
      transform-origin: 100% 0%;
    }
  }
`;


